import {
  RiEyeLine,
  RiSmartphoneLine,
  RiWhatsappLine,
  RiMailLine,
} from "react-icons/ri";

const MessagePreview = ({ message, type, variables }) => {
  const replaceVariables = (text) => {
    let result = text;
    Object.entries(variables).forEach(([key, value]) => {
      result = result.replace(new RegExp(`{${key}}`, "g"), value);
    });
    return result;
  };

  const renderEmailPreview = () => (
    <div className="bg-white rounded-lg shadow-sm border border-secondary-200 overflow-hidden">
      <div className="bg-secondary-50 px-4 py-2 border-b border-secondary-200">
        <div className="text-sm text-secondary-600">From: Your Company</div>
        <div className="text-sm text-secondary-600">To: [Recipient]</div>
      </div>
      <div className="p-4">
        <div className="prose prose-sm">{replaceVariables(message)}</div>
      </div>
    </div>
  );

  const renderMobilePreview = () => (
    <div className="relative w-[280px] h-[500px] mx-auto">
      <div className="absolute inset-0 bg-secondary-900 rounded-[3rem] shadow-xl">
        <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-40 h-6 bg-secondary-800 rounded-b-xl"></div>
        <div className="absolute top-8 inset-x-2 bottom-8 bg-white rounded-xl overflow-hidden">
          <div className="bg-secondary-50 p-3 flex items-center space-x-2 border-b border-secondary-200">
            {type === "whatsapp" ? (
              <RiWhatsappLine className="w-5 h-5 text-success-500" />
            ) : (
              <RiSmartphoneLine className="w-5 h-5 text-primary-500" />
            )}
            <span className="text-sm font-medium">Preview</span>
          </div>
          <div className="p-3">
            <div
              className={`rounded-lg p-3 max-w-[80%] ${
                type === "whatsapp"
                  ? "bg-success-50 text-success-900"
                  : "bg-primary-50 text-primary-900"
              }`}
            >
              {replaceVariables(message)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="space-y-4">
      <div className="flex items-center space-x-2">
        <RiEyeLine className="w-5 h-5 text-primary-500" />
        <h3 className="font-medium text-secondary-900">Message Preview</h3>
      </div>

      {type === "email" ? renderEmailPreview() : renderMobilePreview()}
    </div>
  );
};

export default MessagePreview;
